export default __webpack_public_path__ + "ec39acefd4872522eed185f58a1f56b0.svg";